/* eslint-disable react/no-multi-comp, react/prop-types */

import React from 'react';
import classNames from 'classnames';

const getType = number => {
  if (number > 0) return 'badge-info';
  if (number < 0) return 'badge-danger';
};

// Components
export function Badge({ className, type, number, children, color, ...passed }) {
  const badgeType = type || getType(number);
  const textColor = !badgeType && !color ? 'text-dark' : 'text-white';
  const classes = classNames(className, 'badge', badgeType, textColor);

  if (color) passed.style = { backgroundColor: color };

  return <span {...passed} className={classes}>{children}</span>;
}

export const yesIcon = <span className="yes-icon" />;
export const noIcon = <span className="no-icon" />;
export const dangerIcon = <span className="danger-icon" />;
